export default __webpack_public_path__ + "static/media/cec8d1a9edc960096cd6c202a20ab61f.jpg";